import * as lodash from 'lodash'

export enum PaymentScheduleType {
  AFTER_CHECKIN = 'AFTER_CHECKIN',
  BEFORE_CHECKIN = 'BEFORE_CHECKIN',
  AT_CHECKIN = 'AT_CHECKIN',
  AT_CHECKOUT = 'AT_CHECKOUT',
  AFTER_BOOKING = 'AFTER_BOOKING',
  AFTER_CHECKOUT = 'AFTER_CHECKOUT',
  AT_BOOKING = 'AT_BOOKING',
}

export function hasPaymentScheduleDaysOption(type: PaymentScheduleType) {
  return !lodash.startsWith(type, 'AT_')
}

export const paymentScheduleTypeItems = [
  { value: PaymentScheduleType.BEFORE_CHECKIN, label: $localize`Before Check-in` },
  { value: PaymentScheduleType.AT_CHECKIN, label: $localize`At Check-in` },
  { value: PaymentScheduleType.AFTER_CHECKIN, label: $localize`After Check-in` },
  { value: PaymentScheduleType.AT_CHECKOUT, label: $localize`At Check-out` },
  { value: PaymentScheduleType.AFTER_CHECKOUT, label: $localize`After Check-out` },
  { value: PaymentScheduleType.AT_BOOKING, label: $localize`At booking` },
  { value: PaymentScheduleType.AFTER_BOOKING, label: $localize`After booking` },
]

export type RentalPaymentSchedule = Partial<Record<PaymentScheduleType, { percent: number; days?: number }>>
